@if (chats) {
  <div
    class="header-search"
    [class.header-search_hidden]="!isVisibleBloggers"
  >
    <button
      mat-mini-fab
      color="primary"
      (click)="handelToggleBlogger()"
    >
      <i
        class="arrow-icon"
        [class.left]="isVisibleBloggers"
      ></i>
    </button>
    @if (isVisibleBloggers) {
      <mat-form-field
        appearance="outline"
        class="header-search-input"
        [class.header-search-input_hidden]="!isVisibleBloggers"
      >
        <mat-label>Поиск</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="searchBlogger"
          (ngModelChange)="handleSearchChats()"
        >
      </mat-form-field>
    }
  </div>
}
<div
  class="bloggers"
  [class.bloggers_hidden]="!isVisibleBloggers"
>
  @if (searchChats.length) {
    @for (chat of searchChats; track $index) {
      <button
        class="blogger"
        [class]="{
          'active': isChatActive(chat),
          'blogger_visible': isVisibleBloggers
        }"
          (click)="handleSelectChatClick(chat)"
        >
        <div class="blogger-icon">
          <img
            class="blogger-icon-img"
            [src]="getImage(chat.id)"
            alt=""
          >
        </div>
        @if (isVisibleBloggers) {
          <span
            class="blogger-name"
            [class.blogger_visible]="isVisibleBloggers"
          >
            {{ chat.title }}
          </span>
        }
        @if (chat.unreadCount) {
          <div class="unread-count">
            {{ chat.unreadCount }}
          </div>
        }
      </button>
    }
  } @else {
    <div class="bloggers-empty">Нет чатов</div>
  }
</div>
